import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../lib/ui/Icon'
import Typography from '../../../../lib/ui/Typography'
import styles from './InterestGroup.module.sass'
import classNames from 'classnames/bind'
import { filterLabelsConfigModule } from '../../../../config/sites/river'

const { getKey } = filterLabelsConfigModule

const cx = classNames.bind(styles)

const InterestGroup = ({
  category: categoryDisplay,
  interests = [],
  pendingForDeletion = [],
  partial = false,
  render
}) => {
  const [open, setOpen] = useState(true)
  const handleClick = () => setOpen(!open)
  const pendingForDeletionStr = pendingForDeletion?.map(
    ({ tag: interest, category }) => `${category}-${interest}`
  )
  const mappedInterests = interests
    .filter(
      ({ interest, category }) =>
        pendingForDeletionStr.indexOf(`${category}-${interest}`) === -1
    )
    .sort(({ interest: a }, { interest: b }) =>
      a.toLowerCase().localeCompare(b.toLowerCase())
    )
    .map(render)
  return partial ? (
    mappedInterests
  ) : (
    <Fragment>
      <button
        type="button"
        className={styles.groupLabel}
        onClick={handleClick}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleClick()
          }
        }}
        aria-expanded={open}
      >
        {getKey(categoryDisplay)}
        <Icon
          className={styles.groupIcon}
          icon={open ? 'svg/custom/carat-d' : 'svg/custom/carat-r'}
          colorTier="secondary"
          button
        />
      </button>
      <div className={cx(styles.group, { open })}>
        {mappedInterests.length ? (
          mappedInterests
        ) : (
          <Typography className={styles.message}>
            There are no interests in this category.
          </Typography>
        )}
      </div>
    </Fragment>
  )
}

InterestGroup.propTypes = {
  /**
   * Interest category label
   */
  category: PropTypes.string,
  /**
   * Saved interests held in this category group
   */
  interests: PropTypes.arrayOf(PropTypes.object),
  /**
   * The interest(s) pending deletion
   */
  pendingForDeletion: PropTypes.array,
  /**
   * If `true`, shows only a snippet of full interests
   */
  partial: PropTypes.bool,
  /**
   * Maps the interests with a parent's component
   */
  render: PropTypes.func
}

export default InterestGroup
